<template>
  <div>
    <div
      class="header-book-list dir-rtl header-book-list-book relative flex"
      :class="{ 'show-icons-checked': showActions, 'mobile-header': $_mobile }"
    >
      <!-- <iconsUpdateContainer /> -->
      <div class="icons-check flex" :class="{ 'show-action': showActions }">
        <div class="flex icon-group">
          <baseCheckBox
            class="check-item check-larg"
            :class="{ 'check-minus': checkMinus }"
            @change="checkAll"
            :checked="showActions"
            size="larg"
            :minus="checkMinus"
          />
          <!-- <div class="otz-icon otz-icon-arrow otz-icon-square" @click="toggleAction">o</div> -->
          <baseDropDown class="right list-en">
            <template #button class="list-dropdown">
              <div class="otz-icon otz-icon-arrow otz-icon-square">o</div>
            </template>
            <template #list class="list-dropdown disable">
              <baseItem @click="checkAll(null, true)">{{
                $t("general.selectAll")
              }}</baseItem>
              <baseItem @click="checkAll(null, false)">{{
                $t("general.cancelSelect")
              }}</baseItem>
              <baseItem @click="revert">{{
                $t("general.reverseSelect")
              }}</baseItem>
            </template>
          </baseDropDown>
        </div>
        <div v-if="showActions" class="flex check-all">
          <div
            v-kiosk
            v-if="!$_mobile"
            class="otz-icon-square otz-icon mrg-l-3 show-scale"
            @click="saveSelect"
            v-tooltip="{
              content: this.$t('tooltip.saveSelect'),
              placement: 'left',
            }"
          >
            v
          </div>
          <div
            v-if="!$_mobile"
            @click="addListFavorites"
            v-kiosk
            class="otz-icon-square otz-icon mrg-l-3 favorites-icon-top show-scale"
            :class="{ 'icon-add-fav': getFavoriteCheckBooksCount }"
            v-tooltip="{
              content: getFavoritesTooltip,
              placement: 'top',
            }"
          >
            {{ getFavoritesIcon }}
          </div>
          <div
            @click="doRemoveBooks"
            v-if="
              getCurrentListType == 'SAVED_LIST' ||
              getCurrentListType == 'RECENT_BOOKS'
            "
            class="otz-icon-square otz-icon mrg-l-3 show-scale"
            v-tooltip="{
              content: this.$t('tooltip.garbage'),
              placement: 'top',
            }"
          >
            9
          </div>
          <baseDropDown v-if="!$_mobile" class="menu-list">
            <template #button>
              <div class="otz-icon-square otz-icon mrg-l-3 show-scale">8</div>
              <!-- <div class="icon-circle otz-icon icon-bg" v-tooltip="this.$t('folders.saveList')">o</div> -->
            </template>
            <template #list>
              <baseItem @click="addQuickBtn" v-kiosk>{{
                $t("selectBook.addSelectBookToQuick")
              }}</baseItem>
              <baseItem
                v-kiosk
                v-if="enableHide && !hiddenBooksList"
                v-disable
                @click="addToHiddenBooks"
                >{{ $t("selectBook.hideSelectBook") }}</baseItem
              >
              <baseItem
                v-kiosk
                v-if="enableHide && hiddenBooksList"
                v-disable
                @click="removeHiddenBooks"
                >{{ $t("general.cancelHiddenBook") }}</baseItem
              >

              <baseItemNext v-kiosk.remove>
                <template #next>
                  <baseItem>{{ $t("general.exportSelectBook") }}</baseItem>
                </template>
                <template #list>
                  <baseItem @click="doExportList('pdf')" v-disable>{{
                    $t("general.exportPdf")
                  }}</baseItem>
                  <baseItem @click="doExportList('excel')" v-disable>{{
                    $t("general.exportExel")
                  }}</baseItem>
                </template>
              </baseItemNext>
            </template>
          </baseDropDown>
        </div>
      </div>
      <div
        class="icons-header flex-align-center h-100 flex flex-g-1 flex-bet"
        :class="{ 'show-more': showActions }"
        style="padding-right: 7px"
      >
        <baseDropDown :selfClose="false">
          <template #button>
            <div
              @click="
                $nextTick(() => (maxWidthList = `${$el.offsetWidth - 20}px`))
              "
              v-kiosk
              class="icon-circle otz-icon icon-bg"
              v-tooltip="{
                content: $t('listBooks.lastListBooks'),
                placement: 'left',
              }"
            >
              o
            </div>
            <!-- <div class="icon-circle otz-icon icon-bg" v-tooltip="this.$t('folders.saveList')">o</div> -->
          </template>
          <template v-body #list="{ clicked }">
            <titleAndXHeader
              v-kiosk
              @click="clicked"
              :text="$t('listBooks.lastListBooks')"
            />

            <div
              :style="{ 'max-width': maxWidthList }"
              class="inner-list"
              v-kiosk.remove
            >
              <div class="pinned">
                <baseItem
                  v-for="item in getBookListHistory.filter((i) => i.pin == 1)"
                  :key="item.index"
                  class="item-pin"
                  @click="
                    openHistory(item);
                    clicked();
                  "
                >
                  <div class="history-item">
                    {{ item.title }}
                  </div>

                  <span
                    @click.stop="
                      pinList(item.historyId ? item.historyId : item.id, false)
                    "
                    class="pin text-xxl mef-icon pin"
                    v-tooltip="{
                      content: $t('tooltip.unpin'),
                      placement: 'top',
                    }"
                  >
                    <BaseIcon
                      class="icon x-close"
                      width="13"
                      height="15"
                      nameIcon="pinter-active"
                      pathIcon="icons"
                    />
                  </span>
                </baseItem>
              </div>

              <baseItem
                v-for="item in getBookListHistory.filter((i) => i.pin != 1)"
                :key="item.index"
                @click="
                  openHistory(item);
                  clicked();
                "
              >
                <span class="history-item">{{ item.title }}</span>

                <span
                  @click.stop="
                    pinList(item.historyId ? item.historyId : item.id, true)
                  "
                  class="mef-icon text-xxl"
                  v-tooltip="{ content: $t('tooltip.pin'), placement: 'top' }"
                >
                  <BaseIcon
                    class="icon"
                    width="13"
                    height="15"
                    nameIcon="pinter-gray"
                    pathIcon="icons"
                  /> </span
              ></baseItem>
            </div>
          </template>
        </baseDropDown>
        <div
          class="flex flex-align-center"
          style="flex-grow: 1; position: relative; overflow: hidden"
        >
          <iconRefreshList class="icon-refresh" />
          <div
            v-if="!hidePin"
            class="icon-circle mrg-l-3 otz-icon f-s-20 no-bg"
            :class="{ 'icon-pin-gray': grayPin, 'icon-pin': !grayPin }"
            @click="pinCurrentList()"
            v-tooltip="{ content: this.pinToolTip, placement: 'top' }"
          >
            p
          </div>
          <titleList class="flex-g-1" />
        </div>
        <div class="icons-header-left flex h-100 flex-align-center">
          <div
            class="icon-circle otz-icon icon-otzar"
            v-tooltip="{
              content: this.$t('tooltip.searchIn'),
              placement: 'top',
            }"
            @click="searchInList"
            v-if="showSearch"
          >
            u
          </div>

          <baseDropDown
            v-kiosk
            :class="['left']"
            :selfClose="false"
            v-if="showSettings"
          >
            <template #button class="list-dropdown">
              <div
                class="mef-icon icon-rec"
                style="font-size: 48px; line-height: 21px"
                v-tooltip="{
                  content: $t('mainMenu.settingsName'),
                  placement: 'top',
                }"
              >
                6
              </div>
            </template>
            <template #list="{ clicked }" class="list-dropdown disable">
              <div class="">
                <titleAndXHeader @click="clicked">{{
                  $t("setting.settingListBook")
                }}</titleAndXHeader>
                <div class="list-content">
                  <template v-if="showSdarotOption">
                    <div class="sub-title">
                      {{ $t("setting.titleShowSdarot") }}
                    </div>
                    <li
                      class="item item-check"
                      @click="setSettingOpenSdarot(true)"
                      :class="{ checked: openSdarot }"
                    >
                      <div class="row-menu">
                        <span v-if="openSdarot" class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("setting.openSdarot") }}
                        </div>
                      </div>
                    </li>
                    <li
                      class="item item-check"
                      @click="setSettingOpenSdarot(false)"
                      :class="{ checked: !openSdarot }"
                    >
                      <div class="row-menu">
                        <span v-if="!openSdarot" class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("setting.closeSdarot") }}
                        </div>
                      </div>
                    </li>
                  </template>
                  <div class="underline-separate" v-if="!inSearchInput"></div>
                  <div v-if="!inSearchInput">
                    <div class="sub-title">
                      {{ $t("setting.titleSortList") }}
                    </div>

                    <li
                      class="item item-check"
                      @click="filterByCatg('book')"
                      :class="{
                        checked:
                          userSettings.settings.sortBookList == 'book' ||
                          userSettings.settings.sortBookList == undefined,
                      }"
                    >
                      <div class="row-menu">
                        <span
                          v-if="
                            userSettings.settings.sortBookList == 'book' ||
                            userSettings.settings.sortBookList == undefined
                          "
                          class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("advancSearchBook.nameBook") }}
                        </div>
                      </div>
                    </li>
                    <li
                      class="item item-check"
                      @click="filterByCatg('author')"
                      :class="{
                        checked: userSettings.settings.sortBookList == 'author',
                      }"
                    >
                      <div class="row-menu">
                        <span
                          v-if="userSettings.settings.sortBookList == 'author'"
                          class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("advancSearchBook.author") }}
                        </div>
                      </div>
                    </li>
                    <li
                      class="item item-check"
                      @click="filterByCatg('year')"
                      :class="{
                        checked: userSettings.settings.sortBookList == 'year',
                      }"
                    >
                      <div class="row-menu">
                        <span
                          v-if="userSettings.settings.sortBookList == 'year'"
                          class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("advancSearchBook.year") }}
                        </div>
                      </div>
                    </li>
                    <li
                      class="item item-check"
                      @click="filterByCatg('dorot')"
                      :class="{
                        checked: userSettings.settings.sortBookList == 'dorot',
                      }"
                    >
                      <div class="row-menu">
                        <span
                          v-if="userSettings.settings.sortBookList == 'dorot'"
                          class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("advancSearchBook.dorot") }}
                        </div>
                      </div>
                    </li>
                  </div>
                  <div class="underline-separate"></div>
                  <template>
                    <div class="sub-title">
                      {{ $t("setting.mouseWheelMethod") }}
                    </div>
                    <li
                      class="item item-check"
                      @click="setSettingMouseWheel('book')"
                      :class="{ checked: !mouseWheelScroll }"
                    >
                      <div class="row-menu">
                        <span
                          v-if="!mouseWheelScroll"
                          class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("setting.bookByBook") }}
                        </div>
                      </div>
                    </li>
                    <li
                      class="item item-check"
                      @click="setSettingMouseWheel('scroll')"
                      :class="{ checked: mouseWheelScroll }"
                    >
                      <div class="row-menu">
                        <span
                          v-if="mouseWheelScroll"
                          class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("setting.quickScroll") }}
                        </div>
                      </div>
                    </li>
                  </template>
                  <div class="underline-separate"></div>
                  <template v-if="!openSdarot">
                    <div class="sub-title">
                      {{ $t("setting.sdarotMode") }}
                    </div>
                    <li
                      class="item item-check"
                      @click="setSettingSdarotMode('book')"
                      :class="{ checked: sdarotBookMode }"
                    >
                      <div class="row-menu">
                        <span v-if="sdarotBookMode" class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("setting.openBook") }}
                        </div>
                      </div>
                    </li>
                    <li
                      class="item item-check"
                      @click="setSettingSdarotMode('nobook')"
                      :class="{ checked: !sdarotBookMode }"
                    >
                      <div class="row-menu">
                        <span
                          v-if="!sdarotBookMode"
                          class="font-icon check-icon"
                          >A</span
                        >
                        <div class="row-title">
                          {{ $t("setting.onlySdarot") }}
                        </div>
                      </div>
                    </li>
                  </template>
                </div>
              </div>
            </template>
          </baseDropDown>
          <iconsFolderContainer listType="book" :disable="!showActions" />
        </div>
        <div
          v-if="showSearch"
          class="flex dir-l"
          :class="{ 'flex-g-1': inSearch }"
        >
          <div
            class="icon icon-search-in book-list-search"
            :class="{ search: inSearch }"
          >
            <!-- <div
              class="icon-circle otz-icon"
              @click="searchInList"
              v-if="!inSearch"
            >
              u
            </div> -->

            <div
              class="icon-circle otz-icon close-search"
              style="font-size: 10px; top: 5px"
              @click="searchInList"
              v-if="inSearch"
            >
              F
            </div>
            <input
              class="b-border close div-input-search"
              :class="{ open: inSearch }"
              @focus="loadIndex"
              @blur="freeIndex"
              @keydown="txtSearchIn($event)"
              type="text"
              ref="inputSearch"
              :placeholder="$t('searchInput.placeHolder')"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="action-list padd-b-6" style="display: none">
      <div class="action-list-inner flex flex-bet w-100">
        <div class="flex center-y">
          <div class="flex icon-group">
            <baseCheckBox
              class="check-item check-larg"
              :class="{ 'check-minus': checkMinus }"
              @change="checkAll"
              :checked="showActions"
              size="larg"
              :minus="checkMinus"
            />
            <baseDropDown class="right list-en">
              <template #button class="list-dropdown">
                <div class="otz-icon otz-icon-arrow otz-icon-square">o</div>
              </template>
              <template #list class="list-dropdown disable list-en">
                <baseItem @click="checkAll(null, true)">{{
                  $t("general.selectAll")
                }}</baseItem>
                <baseItem @click="checkAll(null, false)">{{
                  $t("general.cancelSelect")
                }}</baseItem>
                <baseItem @click="revert">{{
                  $t("general.reverseSelect")
                }}</baseItem>
              </template>
            </baseDropDown>
          </div>
          <div v-if="showActions" class="flex check-all">
            <div
              class="otz-icon-square otz-icon mrg-l-3"
              @click="saveSelect"
              v-tooltip="{
                content: this.$t('tooltip.saveSelect'),
                placement: 'top',
              }"
            >
              v
            </div>
            <div
              v-if="!$_mobile"
              @click="addListFavorites"
              class="otz-icon-square otz-icon mrg-l-3 favorites-icon icon-add-fav"
              v-tooltip="{
                content: getFavoritesTooltip,
                placement: 'top',
              }"
            >
              {{ getFavoritesIcon }}
            </div>
            <div
              @click="doRemoveBooks"
              v-if="getCurrentListType == 'SAVED_LIST' && !$_mobile"
              class="otz-icon-square otz-icon mrg-l-3"
              v-tooltip="{
                content: this.$t('tooltip.garbage'),
                placement: 'top',
              }"
            >
              9
            </div>
            <baseDropDown v-if="!$_mobile">
              <template #button>
                <div class="otz-icon-square otz-icon mrg-l-3">8</div>
              </template>
              <template #list>
                <baseItem @click="addQuickBtn" v-kiosk>{{
                  $t("selectBook.addSelectBookToQuick")
                }}</baseItem>
                <baseItem v-if="enableHide" @click="addToHiddenBooks" v-kiosk>{{
                  $t("selectBook.hideSelectBook")
                }}</baseItem>
                <baseItemNext>
                  <template #next>
                    <baseItem>{{ $t("general.exportSelectBook") }}</baseItem>
                  </template>
                  <template #list>
                    <baseItem>{{ $t("general.exportPdf") }}</baseItem>
                    <baseItem @click="doExportList('excel')">{{
                      $t("general.exportExel")
                    }}</baseItem>
                  </template>
                </baseItemNext>
              </template>
            </baseDropDown>
          </div>
          -->
        </div>
        <div class="flex w-100 dir-l" :class="{ 'flex-g-1': inSearch }">
          <div
            class="icon icon-search-in"
            :class="{ search: inSearch }"
            v-if="showSearch"
          >
            <div
              class="icon-circle otz-icon"
              @click="searchInList"
              v-if="!inSearch"
            >
              u
            </div>
            <div
              class="icon-circle otz-icon close-search"
              style="font-size: 10px"
              @click="searchInList"
              v-if="inSearch"
            >
              F
            </div>
            <baseInput
              class="b-border close"
              :class="{ open: inSearch }"
              @focus="loadIndex"
              @blur="freeIndex"
              @input="txtSearchIn($event)"
              text
              :placeholder="$t('searchInput.placeHolder')"
            />
          </div>
        </div>

        <!-- <baseDropDown :class="['left zoom']" :selfClose="false">
          <template #button class="list-dropdown">
            <div
              class="icon-pin mrg-l-3 mef-icon icon-circle"
              style="font-size: 48px;line-height: 21px;"
            >
              6
            </div>
          </template>
          <template #list="{ clicked }" class="list-dropdown disable">
            <div class="">
              <titleAndXHeader @click="clicked">{{
                $t("setting.settingListBook")
              }}</titleAndXHeader>
              <div class="list-content">
                <div class="title">
                  {{ $t("setting.titleShowSdarot") }}
                </div>
                <li
                  class="item item-check"
                  @click="setSettingOpenSdarot(true)"
                  :class="{ checked: openSdarot }"
                >
                  <div class="row-menu">
                    <span v-if="openSdarot" class="font-icon check-icon"
                      >A</span
                    >
                    <div class="row-title">{{ $t("setting.openSdarot") }}</div>
                  </div>
                </li>
                <li
                  class="item item-check"
                  @click="setSettingOpenSdarot(false)"
                  :class="{ checked: !openSdarot }"
                >
                  <div class="row-menu">
                    <span v-if="!openSdarot" class="font-icon check-icon"
                      >A</span
                    >
                    <div class="row-title">{{ $t("setting.closeSdarot") }}</div>
                  </div>
                </li>
                <div class="title border-t-light">
                  {{ $t("setting.titleSortList") }}
                </div>

                <li
                  class="item item-check"
                  @click="filterByCatg('book')"
                  :class="{ checked: openSdarot }"
                >
                  <div class="row-menu">
                    <span v-if="openSdarot" class="font-icon check-icon"
                      >A</span
                    >
                    <div class="row-title">
                      {{ $t("advancSearchBook.nameBook") }}
                    </div>
                  </div>
                </li>
                <li
                  class="item item-check"
                  @click="filterByCatg('author')"
                  :class="{ checked: !openSdarot }"
                >
                  <div class="row-menu">
                    <span v-if="!openSdarot" class="font-icon check-icon"
                      >A</span
                    >
                    <div class="row-title">
                      {{ $t("advancSearchBook.author") }}
                    </div>
                  </div>
                </li>
              </div>
            </div>

          </template>
        </baseDropDown> -->

        <!-- <ComboboxInput
          v-if="showOrder"
          class="fit-height"
          :labal="label"
          :labelKey="label"
          :items="catgList"
          @input="filterByCatg($event)"
          :labelStart="labelStart"
        /> -->
      </div>
      <!-- {{ typeList }} -->
      <!-- <actionsItemContainer v-if="showAction" @click-close="closeAction" /> -->
    </div>
  </div>
</template>

<script>
import {
  printResultsList,
  printPreview,
  stopProcessBar,
} from "@/services/bookLists.js";
import iconRefreshList from "@/components/listBookArea/headerBookListContainer/iconsUpdateList/iconRefreshList.vue";
import iconsUpdateContainer from "@/components/listBookArea/headerBookListContainer/iconsUpdateList/iconsUpdateListContainer.vue";
import titleList from "@/components/listBookArea/headerBookListContainer/titleList.vue";
import iconsFolderContainer from "@/components/listBookArea/headerBookListContainer/iconFolderList/iconFolderListContainer.vue";

// import actionsItemContainer from "@/components/listBookArea/headerBookListContainer/iconsUpdateList/actionsCheckbookContainer.vue";
import * as history from "@/services/history.js";

import { mapActions, mapGetters, mapState } from "vuex";
import { IPUserNoPersDataMsg } from "@/services/userBooksData.js";
import mixBooksIndexManager from "@/mixing/mixSearchIndexMemoryManager.js";
import mixInputCharsTranslate from "@/mixing/mixInputCharsTranslate";
export default {
  mixins: [mixBooksIndexManager, mixInputCharsTranslate],
  props: {
    showRefresh: {
      default: true,
    },
  },
  components: {
    // actionsItemContainer,
    iconsUpdateContainer,
    titleList,
    iconRefreshList,
    iconsFolderContainer,
  },
  mounted() {
    this.maxWidthList = `${this.$el.offsetWidth - 20}px`;
  },
  sockets: {
    connect: function () {},
    createdPdf: function (res) {
      if (res.error) {
        this.$store.state.progressWindow.topMessage = "";
        this.$store.state.progressWindow.bottomMessage = `${
          res.desc.endsWith(" ENOENT")
            ? this.$t("general.error") + ": " + this.$t("general.missingPlugin")
            : this.$t("general.error") + ": " + res.desc
        }`;
        this.$store.state.progressWindow.hideProg = true;
        stopProcessBar();
        return;
      }
      if (res.pageCount) {
        this.$store.state.progressWindow.bottomMessage = `${
          res.pageNumber
        } ${this.$t("general.ofResults")} ${res.pageCount}`;

        return;
      }
      this.$store.state.progressWindow.show = false;
      this.$store.state.progressWindow.bottomMessage = "";
      stopProcessBar();
      printPreview(res);
    },
  },
  data() {
    return {
      labelKey: 0,
      inSearch: false,
      labelStart: 0,
      action: true,
      maxWidthList: 250,
    };
  },
  computed: {
    ...mapGetters("bookList", [
      "getCheckedBooks",
      "getBookListHistory",
      "getCurrentListType",
      "getFavoriteCheckBooksCount",
    ]),
    // getDataOfCurrentList
    ...mapGetters("booklistComp", [
      "hasCheckAll",
      "hasCheckedTop",
      "getLengthListCheck",
    ]),
    ...mapState("bookList", ["historyUsersActions", "textSearch", "pinChecks"]),
    ...mapState("userFavoriteBooks", ["favoriteChange"]),

    ...mapGetters("bookList", [
      "getTextSearchInput",
      "getBooksCount",
      "getChecksCount",
      "getDoNotFocus",
    ]),
    ...mapGetters("user", ["isIPLimited"]),
    systemMaagarim() {
      return (
        this.currentListData.type == "SYSTEM_LIST" &&
        this.currentListData.categoryTypeId === 4
      );
    },
    showSettings() {
      return this.currentListData.type !== "RECENT_BOOKS";
    },
    showSdarotOption() {
      return this.systemMaagarim || this.isInSearch || this.allBooks;
    },
    grayPin() {
      return this.currentListData.pin != 1 || this.isInSearch;
    },
    enableHide() {
      return this.userSettings.settings.enableHidden != "0";
    },
    label() {
      return this.$t("freeSearchResults.sortBy");
    },

    getFavoritesTooltip() {
      let checked = this.getFavoriteCheckBooksCount;
      return checked == 1
        ? this.$t("toolbox.removefavorites")
        : this.$t("toolbox.favorites");
    },
    getFavoritesIcon() {
      let checked = this.getFavoriteCheckBooksCount;
      return checked == 1 ? "0" : "P";
    },
    hidePin() {
      return (
        this.currentListData.type == "ALL" && this.getTextSearchInput == ""
      );
      //    (this.currentListData.type != "SEARCH" && this.getTextSearchInput != "")
      // );
    },
    allBooks() {
      if (this.currentListData.type == "ALL" && this.textSearch == "") {
        return true;
      }
      return false;
    },
    catgList() {
      return [
        { label: this.$t("changeBookInfo.bookName"), key: 0, name: "book" },
        { label: this.$t("changeBookInfo.authorName"), key: 1, name: "author" },
      ];
    },
    checkMinus() {
      let booksCount = this.getBooksCount;
      let checksCount = this.getChecksCount;
      return checksCount > 0 && checksCount < booksCount;
      //if (Length != this.getLengthListCheckFree) return true;
      //return false;
    },
    showActions() {
      return this.getChecksCount > 0;
    },
    nameSearch() {
      if (this.$store.state.lastTxtSearch === undefined) {
        // console.dir(this.$store.state.lastTxtSearch);
        return this.$t("searchIn.allBooks");
      }
      return $store.state.lastTxtSearch;
    },
    showOrder() {
      if (this.getTextSearchInput && this.getTextSearchInput.length > 0)
        return false;
      if (
        this.currentListData.type == "ALL" ||
        this.currentListData.type == "SYSTEM_LIST" ||
        this.currentListData.type == "CUSTOM_LIST" ||
        this.currentListData.type == "HIDDEN_LIST" ||
        this.currentListData.type == "SAVED_LIST" ||
        this.currentListData.type == "RECENT_BOOKS" ||
        this.currentListData.type == "SYSTEM_MULTIPLE_LISTS"
      )
        return true;
      return false;
    },
    showSearch() {
      if (this.getTextSearchInput && this.getTextSearchInput.length > 0)
        return false;
      if (
        [
          "RECENT_BOOKS",
          "SYSTEM_LIST",
          "CUSTOM_LIST",
          "SAVED_LIST",
          "SYSTEM_MULTIPLE_LISTS",
        ].includes(this.currentListData.type)
      )
        return true;
      return false;
    },

    pinToolTip() {
      return this.currentListData.pin != 1 || this.isInSearch
        ? this.$t("tooltip.pin")
        : this.$t("tooltip.unpin");
    },
    currentListData() {
      let currentList =
        this.$store.getters["bookList/getDataOfCurrentList"].data;
      return currentList;
    },
    openSdarot() {
      if (!this.userSettings.settings.open_sdarot) return false;
      if (this.userSettings.settings.open_sdarot == "1") return true;
      return false;
    },
    sdarotBookMode() {
      return this.userSettings.settings.sdarot_mode === "book";
      if (!this.userSettings.settings.mouse_wheel) return false;
      if (this.userSettings.settings.mouse_wheel == "scroll") return true;
      return false;
    },
    mouseWheelScroll() {
      return (
        !this.userSettings.settings.mouse_wheel ||
        this.userSettings.settings.mouse_wheel === "scroll"
      );
      if (!this.userSettings.settings.mouse_wheel) return false;
      if (this.userSettings.settings.mouse_wheel == "scroll") return true;
      return false;
    },
    inSearchInput() {
      if (
        (this.currentListData.type == "ALL" &&
          this.getTextSearchInput.trim() == "") ||
        this.currentListData.type == "SYSTEM_LIST" ||
        this.currentListData.type == "SAVED_LIST" ||
        this.currentListData.type == "SYSTEM_MULTIPLE_LISTS" ||
        this.currentListData.type == "RECENT_BOOKS" ||
        this.currentListData.type == "CUSTOM_LIST"
      ) {
        return false;
      }
      return true;
    },
    showBookVolumes() {
      let listType = this.getCurrentListType;

      return (
        ["SEARCH", "ALL", "AUTHOR_LIST", "SAVED_LIST"].includes(listType) ||
        this.yesodBook ||
        this.systemMaagarim
      );
    },
    yesodBook() {
      return (
        this.currentListData.type == "CUSTOM_LIST" &&
        this.currentListData.content == "ספרי יסוד"
      );
    },
    systemMaagarim() {
      return (
        this.currentListData.type == "SYSTEM_LIST" &&
        this.currentListData.categoryTypeId === 4
      );
    },
    hiddenBooksList() {
      return this.currentListData.type === "HIDDEN_LIST";
    },
    isInSearch() {
      return (
        (this.currentListData.type !== "SEARCH" &&
          this.getTextSearchInput !== "") ||
        (this.currentListData.type === "SEARCH" &&
          this.getTextSearchInput !== this.currentListData.content)
      );
    },
  },

  methods: {
    ...mapActions("userFavoriteBooks", [
      "addFavoriteBook",
      "removeFavoriteBook",
    ]),
    ...mapActions("bookList", [
      "removeBooks",
      "saveFsList",
      "checkAllBooks",
      "revertChecks",
      "goToHistory",
      "setDoNotFocus",
    ]),
    ...mapActions("booklistComp", ["checkAllListBooks"]),
    openHistory(item) {
      this.goToHistory({ id: item.index });
      // this.clicked();
      // this.$store.state.bookList.initBook = 143448;
    },
    doExportList(type) {
      let closeSdarot = false;

      if (this.openSdarot) closeSdarot = false;
      else closeSdarot = this.showBookVolumes;
      printResultsList(type, closeSdarot, "book");
    },

    setSettingOpenSdarot(val) {
      this.userSettings.setSettings("open_sdarot", val);
      this.$store.dispatch("bookList/setShowVols", val, { root: true });
    },
    setSettingMouseWheel(val) {
      this.userSettings.setSettings("mouse_wheel", val);
    },
    setSettingSdarotMode(val) {
      this.userSettings.setSettings("sdarot_mode", val);
    },
    pinCurrentList(pin) {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      //if it is a search list that is not yet in history
      if (this.isInSearch) {
        let payload = {
          type: "SEARCH",
          content: "",
          pin: true,
        };
        this.$store.dispatch("bookList/addUserActionToHistory", payload);
        return;
      }
      if (pin == undefined) pin = this.currentListData.pin == 1 ? false : true;
      if (
        pin &&
        this.getBookListHistory.filter((i) => i.pin == 1).length >= 5
      ) {
        let msg = this.$t("listBooks.dontPinMoreFiveList");
        const notification = {
          type: "error",
          message: msg,
          timeout: 2000,
        };
        this.$notify(notification);
        return;
      }
      let currentList = this.currentListData;
      let id = currentList.historyId ? currentList.historyId : currentList.id;
      if (id == undefined) return;

      history.setSearchHistoryPin({ id, pin }).then(() => {
        this.$store.dispatch("bookList/setPin", { id, pin }, { root: true });
      });
    },
    pinList(id, pin = true) {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      if (
        pin &&
        this.getBookListHistory.filter((i) => i.pin == 1).length >= 5
      ) {
        let msg = this.$t("listBooks.dontPinMoreFiveList");
        const notification = {
          type: "error",
          message: msg,
          timeout: 2000,
        };
        this.$notify(notification);
        return;
      }
      history.setSearchHistoryPin({ id, pin }).then(() => {
        this.$store.dispatch("bookList/setPin", { id, pin }, { root: true });
      });
    },
    async removeHiddenBooks() {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      let books = this.getCheckedBooks;
      let msg;
      msg =
        books.length == 1
          ? this.$t("hiddenbooks.sureCancelHiddenBooks")
          : this.$t("hiddenbooks.sureCancelHiddenBook");
      let payload = {
        title: this.$t("general.remove2"),
        content: msg,
        btns: [this.$t("general.yes"), this.$t("general.no")],
      };
      let act = await this.$msg(payload);
      if (act != this.$t("general.yes")) {
        return;
      }

      let alreadyHidden = this.userSettings.settings.hiddenBooks
        ? this.userSettings.settings.hiddenBooks
        : [];
      if (typeof alreadyHidden == "string")
        alreadyHidden = JSON.parse(alreadyHidden);
      //remove selected books
      let hiddenBooks = alreadyHidden.filter((b) => !books.includes(b));
      try {
        await this.userSettings.setSettings(
          "hiddenBooks",
          JSON.stringify(hiddenBooks)
        );

        this.$store.dispatch("books/unsetHiddenBooks", books);

        msg =
          books.length == 1
            ? this.$t("hiddenbooks.succeedCancel")
            : this.$t("hiddenbooks.succeedCancel");
        const notification = {
          type: "success",
          message: msg,
          timeout: 2000,
        };
        this.$notify(notification);
      } catch {
        const notification = {
          type: "error",
          message: "error occured",
          timeout: 2000,
        };
        this.$notify(notification);
      }
    },
    async addToHiddenBooks() {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      let payload = {
        title: this.$t("general.remove2"),
        content: this.$t("hideBookQuestion"),
        btns: [this.$t("general.yes"), this.$t("general.no")],
      };
      let act = await this.$msg(payload);
      if (act != this.$t("general.yes")) {
        return;
      }
      let books = this.getCheckedBooks;
      let alreadyHidden = this.userSettings.settings.hiddenBooks
        ? this.userSettings.settings.hiddenBooks
        : [];
      if (typeof alreadyHidden == "string")
        alreadyHidden = JSON.parse(alreadyHidden);
      //remove dups
      let hiddenBooks = new Set([...books, ...alreadyHidden]);
      hiddenBooks = Array.from(hiddenBooks);
      try {
        await this.userSettings.setSettings(
          "hiddenBooks",
          JSON.stringify(hiddenBooks)
        );

        this.$store.dispatch("books/setHiddenBooks", hiddenBooks);
        const notification = {
          type: "success",
          message: this.$t("hideBookSuccess"),

          timeout: 2000,
        };
        this.$notify(notification);
      } catch {
        const notification = {
          type: "error",
          message: "error occured",
          timeout: 2000,
        };
        this.$notify(notification);
      }
    },
    addQuickBtn() {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      this.$store.dispatch("popupOnceComp/setSlotShow", "add-quick-books");
      this.$store.dispatch("popupOnceComp/toggleVisible");
    },
    async doRemoveBooks() {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      let content = this.$t("selectBook.removeBookQ");
      if (this.getChecksCount > 1) content = this.$t("selectBook.removeBooksQ");
      let payload = {
        title: this.$t("selectBook.deleteBookInList"),
        content: content,

        btns: [this.$t("general.yes"), this.$t("general.no")],
      };
      let act = await this.$msg(payload);
      if (act == this.$t("general.no") || act == "") return;
      if (
        this.currentListData.type == "SAVED_LIST" ||
        this.currentListData.type == "RECENT_BOOKS"
      ) {
        let folders = {
          id: this.currentListData.listId || this.currentListData.id,
          books: this.getCheckedBooks,
        };
        this.$store.dispatch("folders/userFolderListDeleteBooks", folders);
        if (
          this.currentListData.content === "favorites" ||
          this.currentListData.content === "מועדפים"
        ) {
          //remove from favorites books module
          this.$store.dispatch("userFavoriteBooks/delFavoriteBooks", {
            books: this.getCheckedBooks,
          });
        }
        if (this.currentListData.type == "RECENT_BOOKS") {
          //remove from recent books module
          this.$store.dispatch(
            "userRecentBooks/removeRecentBooks",
            this.getCheckedBooks
          );
        }
      }
      content = this.$t("selectBook.removeSelectBook");
      const notification = {
        type: "success",
        message: content,
        timeout: 2000,
        setting: {
          grid: "progress",
          nameIcon: "icon-garbage-color",

          position: "center",
        },
      };
      this.$notify(notification);
      this.$store.dispatch("quickButtons/setQuickButtonsData", null, {
        root: true,
      });
    },
    revert() {
      this.revertChecks();
    },
    closeAction() {
      this.action = false;
    },
    toggleAction() {
      this.action = !this.action;
    },
    txtSearchIn(e) {
      // setBooksListSearchTo
      if (!this.isSpecialKeys(e)) {
        this.handleKeydown(e, this.$refs.inputSearch);
      }
      this.$store.dispatch("bookList/setDoNotFocus", true);
      this.$store.dispatch("bookList/setBooksListSearchTo", e.target.value);
    },
    checkAll($event, check) {
      if (check == undefined) check = $event.target.checked;
      this.$emit("checkall", check);
    },
    searchInList() {
      if (!this.inSearch) {
        this.inSearch = true;
        setTimeout(() => {
          this.$refs.inputSearch.focus();
        }, 10);
      } else {
        this.inSearch = false;
        this.$refs.inputSearch.value = "";

        this.$store.dispatch("bookList/setBooksListSearchTo", "");
      }
      return;
    },

    // filterByCatg($event) {
    //   this.label = $event.label;
    //   this.labelKey = $event.labelKey;
    //   this.userSettings.setSettings("sortBookList", $event.name);
    //   this.$store.dispatch("booklistComp/setSortByList", $event.name);
    // },
    filterByCatg(sort) {
      this.userSettings.setSettings("sortBookList", sort);
      this.$store.dispatch("booklistComp/setSortByList", sort);
    },
    saveSelect() {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      this.$store.dispatch("folders/setOpenTypePopup", "export").then(() => {
        this.$store.dispatch("folders/setListType", "book").then(() => {
          this.$store.dispatch("folders/togglePopupFolder", true);
        });
      });
    },
    addListFavorites() {
      let books = this.getCheckedBooks;
      this.getFavoriteCheckBooksCount == 1
        ? this.removeFavoriteBook({ books })
        : this.addFavoriteBook({ books });
    },
  },
  watch: {
    hasCheckedTop: function (val) {
      if (!val) {
        this.action = true;
      }
    },
  },
};
</script>

<style lang="scss">
.inner-list {
  max-height: 250px;
  overflow: auto;
}
.icons-check {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  // margin-left: 7px;
  height: 100%;
  align-items: center;
}
.icons-header {
  max-width: calc(100% - 42px);
  &.show-more {
    max-width: calc(100% - 118px);
  }
}
.icons-header-left {
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  margin-right: 7px;
  padding-right: 5px;
  padding-left: 5px;
}
.action-list-inner .check-larg input:checked + .checkmark {
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.29);
  border: 1.5px solid #7b7b7b;
}
.action-list-inner {
  .arrow-combo-bottom {
    height: 23px;
    width: 14px;
    position: relative;
    right: -4px;
    transition: 0.3s;
    border-radius: 3px;
    &:hover {
      background: #00000014;
    }
    svg {
      position: absolute;
      top: 51%;
      left: 51%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
}
.icon-pin {
  font-size: 28px;
}
.list-content {
  .underline-separate {
    margin: 6px 0 12px;
  }
  .title {
    color: #7f7f7f;
    font-size: 13px;
    font-weight: bold;
    padding: 0px 20px 0 0;
  }
  .item.checked {
    color: var(--custom-color1);
    height: 36px;
  }
  .item.item-check {
    font-size: 14px;
    height: 36px !important;
    line-height: 36px !important;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .item.item-check .row-menu {
    padding: 0 30px 0 20px;
  }
  .item.item-check .font-icon {
    margin-right: -24px;
    right: 13px;
    margin-left: 10px;
    height: 36px;
    line-height: 36px;
    color: var(--custom-color1);
    font-size: 14px;
  }
}
.pinned .item:last-child {
  border-bottom: 1px solid #e4e4e4;
}
.div-input-search {
  position: absolute;
  top: 0;
  width: calc(100% - 50px);
  left: 2px;
  background-color: var(--bg-color3);
  text-align: right;
  height: 100%;
  border: 0;
  border-bottom: 1px solid;
  direction: rtl;
  color: var(--text-color1);
}

.favorites-icon {
  font-size: 28px;
}
.close-search {
  position: absolute;
  z-index: 1;
  left: 2px;
  top: 0;
}

.icon-pin-gray {
  color: rgba(0, 0, 0, 0.3) !important;
}
</style>
